import {
  BooleanType,
  ConditionalGroupType,
  DateTimeType,
  DateType,
  DropDownType,
  ExpressionType,
  GroupType,
  ImageType,
  NumberType,
  SignatureType,
  StringType,
  TimeType,
} from "./types";
import { QuestionDataType } from "operations/schema/schema";

export const DataTypeComponents = {
  [QuestionDataType.Boolean]: BooleanType,
  [QuestionDataType.ConditionalGroup]: GroupType,
  [QuestionDataType.Date]: DateType,
  [QuestionDataType.DateTime]: DateTimeType,
  [QuestionDataType.Decimal]: NumberType,
  [QuestionDataType.DropDown]: DropDownType,
  [QuestionDataType.Expression]: ExpressionType,
  [QuestionDataType.Group]: ConditionalGroupType,
  [QuestionDataType.Image]: ImageType,
  [QuestionDataType.Int32]: NumberType,
  [QuestionDataType.Signature]: SignatureType,
  [QuestionDataType.String]: StringType,
  [QuestionDataType.TimeOfDay]: TimeType,
};